<template>
  <div class="left-box">
    <h2>{{ $t('commodity.Components.NewTime.NewIn') }}</h2>
    <vue-scroll style="height: calc(100vh - 225px);">
      <div class="pointer" v-for="(item,index) in dateLine" :key="index" :class="{'is-active':index===activeIndex}" @click="getTimeValue(item,index)">{{item}}</div>
    </vue-scroll>
  </div>
</template>

<script>
// import _ from 'lodash'
import API from '@/api'
import { dateFormat } from '@/util/date'
export default {

  data() {
    return {
      activeIndex: undefined,
      dateLine: []
    }
  },
  created() {
    this.getDateLine()
  },

  methods: {
    getDateLine() {
      API.getDateLine().then(res => {
        this.dateLine = res.data
        // let dates = this.getTime()
        // this.dateLine = _.intersection(res.data, dates)
        this.activeIndex = 0
        this.getTimeValue(this.dateLine[0], 0)
      })
    },
    getTime() {
      let date = new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 91)
      let dates = []
      for (let i = 1; i <= 90; i++) {
        dates.unshift(dateFormat(date + (3600 * 1000 * 24 * i), 'yyyy-MM-dd'))
      }
      return dates
    },
    getTimeValue(item, index) {
      this.activeIndex = index
      this.$emit('selectTime', item)
    }
  }

}
</script>

<style lang="scss" scoped>
.left-box {
  // margin-top: 30px;
  width: 250px;
  margin-right: 16px;
  border: 1px solid #f4f6f9;
  padding: 30px 0 0 0;
  padding-left: 0px;

  h2 {
    padding-bottom: 23px;
    color: #1f2937;
    font-weight: 600;
    font-size: 16px;
    padding-left: 25px;
    line-height: 24px;
  }
  div {
    font-weight: 400;
    font-size: 14px;
    width: 100%;
    padding-left: 25px;
    line-height: 40px;
    color: #747a87;
  }
}
.is-active {
  background: rgba(153, 196, 28, 0.06);
  color: #99c41c !important;
}

</style>
